import { render, staticRenderFns } from "./FaqPartial.htm?vue&type=template&id=344d2b4c&scoped=true&external"
import script from "./FaqPartial.js?vue&type=script&lang=js&external"
export * from "./FaqPartial.js?vue&type=script&lang=js&external"
import style0 from "./FaqPartial.scss?vue&type=style&index=0&id=344d2b4c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344d2b4c",
  null
  
)

export default component.exports